import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { FiShield, FiClock, FiHome, FiMessageSquare } from "react-icons/fi";
import "swiper/css";
import { Link } from "react-router-dom";
import { useHiddenCategories } from "../../api/hiddenCategories";
import "swiper/css/pagination";
const features = [
  {
    icon: <FiShield />,
    title: "100% CERTIFIED",
    text: "GIA, IGI & Govt. Lab tested on every gem",
  },
  {
    icon: <FiClock />,
    title: "SHIPS IN 48 HOURS",
    text: "Energized & dispatched within 2 days",
  },
  {
    icon: <FiHome />,
    title: "VEDIC ENERGIZATION",
    text: "Ritually activated by expert pandits",
  },
  {
    icon: <FiMessageSquare />,
    title: "GUIDENCE & CONSULTATION",
    text: "Personalized gem guidance by experts",
  },
];
const slides = [
  {
    image:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791223867/file_0000000075848209a1934ccb6fe7f9f9.png",
    mainCategory: "rudrakshas",
  },
 {
    image:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791223862/file_00000000830c820b83946e3d3a63602d.png",
    mainCategory: "shivling",
  },

  {
    image:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791223859/file_00000000986881faadbc523474f18f7d.png",
    mainCategory: "shankh-sea-shells",
  },
  {
    image:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791307452/ed79f0c9-c33e-4d3b-8ac9-0af8030d76b0.png",
    mainCategory: "shaligram",
  },
  {
    image:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791305442/file_00000000bcd481fa8f94e6912b9b9083.png",
    mainCategory: "vastu-products",
  },
  {
    image:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791305278/file_00000000fc148211bb4b4f40654e78ed.png",
    mainCategory: "pooja",
  },
  {
    image:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791303565/file_000000009c8881fa9e736ee0bff783ed.png",
    mainCategory: "gemstones",
  },
 {
    image:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791303566/file_0000000068ac8211992703772e3bb3e8.png",
    mainCategory: "perfumes",
  },
   {
    image:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791303566/file_000000006870820b9519dd539af0b983.png",
    mainCategory: "crystals",
  },
   {
    image:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791303563/file_00000000d11482119f35bc58055f943b.png",
    mainCategory: "tulsi",
  },
];

export default function HeroSlider() {
  const { isCategoryHidden } = useHiddenCategories();
  // A slide for a category the admin has hidden would link to a dead page.
  const visibleSlides = slides.filter((item) => !isCategoryHidden(item.mainCategory));
  return (
    <>
      <section className="als-slider">
        <Swiper
          modules={[Autoplay, Pagination]}
          slidesPerView={1.07}
          spaceBetween={4}
          centeredSlides={false}
          loop={true}
          speed={600}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
        >
          {visibleSlides.map((item, index) => (
            <SwiperSlide key={index}>
              <Link to={`/shop/${item.mainCategory}`}>
                <img src={item.image} alt="" className="als-bg" />
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className="vvFeatures-bar">
        <div className="vvFeatures-container">
          {features.map((item, index) => (
            <div className="vvFeature-card" key={index}>
              <div className="vvFeature-icon">{item.icon}</div>
              <div className="vvFeature-content">
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
